<template>
  <div>
    <section class="footer">
      <el-row>
        <el-col :span="8" :xs="24">
          <p class="title">{{ $t('D465') }}</p>
          <div class="cont about">
            <el-row>
              <!-- <el-col :span="6" :xs="12">
              <a class="txt" href="javascript: void(0);" @click="$router.push('/abstract')">{{$t('D461')}}</a>
            </el-col> -->
              <el-col :span="6" :xs="12">
                <a
                  class="txt"
                  href="javascript: void(0);"
                  @click="DialogVisible"
                  >{{ $t('D462') }}</a
                >
              </el-col>
              <el-col :span="6" :xs="12">
                <a class="txt" href="javascript: void(0);" @click="goCat">{{
                  $t('D463')
                }}</a>
              </el-col>
              <el-col :span="6" :xs="12">
                <a
                  class="txt"
                  href="javascript: void(0);"
                  @click="$router.push('/privacy')"
                  >{{ $t('D464') }}</a
                >
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <p class="title">{{ $t('D466') }}</p>
          <div class="cont connect">
            <div class="service-contact">
              <img :src="require('@/assets/index/connect-us.svg')" />
              <span>service@xieco.net</span>
            </div>
            <div class="service-contact">
            <img :src="require('@/assets/index/telephone.svg')">
            <span>134 8611 1166</span>
          </div>
            <div class="service-contact">
              <img :src="require('@/assets/index/qq.svg')" />
              <span>2230259928</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <p class="title">{{ $t('D467') }}</p>
          <div class="cont wx">
            <img class="qr-code" :src="require('@/assets/index/qrCode1.jpg')" />
          </div>
        </el-col>
        <el-col v-if="false" :span="24">
          <p class="title">{{ $t('D468') }}</p>
          <ul class="cont link-list">
            <li
              class="link-item"
              v-for="(item, index) in linkList"
              :key="index"
              @clic="goLink(item.link)"
            >
              <a :href="item.link">{{ item.name }}</a>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-dialog
        :title="$t('D350')"
        :visible.sync="centerDialogVisible"
        width="610px"
        center
      >
        <span>{{ $t('D351') }}（{{ $t('_5FF8D4C1679F272E') }}）</span>
        <div style="margin: 10px 0"></div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 12 }"
          :placeholder="$t('D352')"
          v-model="content"
        >
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit()">{{
            $t('D191')
          }}</el-button>
          <el-button @click="centerDialogVisible = false">{{
            $t('SEARCH_05')
          }}</el-button>
        </span>
      </el-dialog>
    </section>
    <el-footer class="beian"
      >© Xieco {{ year }}. All Rights Reserved.&nbsp;
      <a href="https://beian.miit.gov.cn/#" target="_blank">
        {{ $t('D414') }}</a
      >
    </el-footer>
  </div>
</template>
<script>
import { FeedbackSubmit, ipCountry, linksList } from '../../api/api'
export default {
  name: 'index',
  data() {
    return {
      content: '',
      centerDialogVisible: false,
      linkList: [],
      year: 2024
    }
  },
  computed: {
    isVisitor() {
      return !this.$store.state.token ? true : false
    },
    getLange() {
      return this.$store.state.language
    },
  },
  methods: {
    goCat() {
      window.location.href = `${window.location.protocol}//${window.location.host}/directory/company-more`
    },
    homePageTap(type) {
      let url = type
        ? 'https://twitter.com/Datadeta_DI'
        : 'https://www.facebook.com/DataDeta.Intelligence/'
      window.open(url)
    },
    DialogVisible() {
      if (this.isVisitor == true) {
        this.$emit('loGin', 1)
      } else {
        this.centerDialogVisible = true
        this.content = ''
      }
    },
    submit() {
      if (this.content.length < 5) {
        this.$message({
          message: this.$t('_82725C780D821B2D'),
          type: 'warning',
        })
        return
      }
      FeedbackSubmit({ content: this.content })
        .then((res) => {
          if (res.data.ret !== 0) {
            this.$message({
              message: this.$t(res.data.msg),
              type: 'warning',
            })
          } else {
            this.$message({
              // message: this.$t(res.data.msg),
              showClose: true,
              message: this.$t('D353'),
              type: 'success',
            })
            this.centerDialogVisible = false
            if (window.ga) {
              ga('send', 'event', '用户', '用户反馈', '用户')
            }
          }
        })
        .catch(function (error) {
          console.log('发生错误！', error)
        })
    },
    linksList() {
      linksList()
        .then((res) => {
          if (res.data.ret !== 0) {
            this.$message({ message: this.$t(res.data.msg), type: 'warning' })
          } else {
            this.linkList = { ...res.data.data }
          }
        })
        .catch(function (error) {
          console.log('发生错误！', error)
        })
    },
  },
  created() {
    var dt=new Date();
    this.year = dt.getFullYear();
    this.linksList()
    let ip_isCn = window.sessionStorage.getItem('ip_isCn')
    if (!ip_isCn) {
      ipCountry().then((res) => {
        this.ip_isCn = res.data.ret === 0 ? true : false
      })
    } else {
      this.ip_isCn = JSON.parse(ip_isCn)
    }
  },
}
</script>
<style scoped lang="less">
@import '../../styles/footer';
</style>



// WEBPACK FOOTER //
// index.vue?61228582